import { Product, SkeletonProduct } from "../../types/types";

export const getProductKey = (product: Product | SkeletonProduct): string => {
  return `${product.aliases.pimProductId}-${product.__typename !== "SkeletonProduct" && product.advertising ? "sponsored" : "standard"}`;
};
